import { push } from 'react-router-redux'
import { call, put, takeEvery } from 'redux-saga/effects'
import { gCall, is_ok, redirectTo, webOs } from './utils'
import * as route from '../routes'
import * as action from '../actions'
import api from '../middleware/api'

function* watchForUserInfoFetchSucceeded() {
  yield takeEvery(action.USER_INFO_FETCH_SUCCEEDED,
    gCall(
      api.new_events,
      action.newEventsFetchSucceeded,
      action.newEventsFetchFailed,
    ))
}

function* watchForLoginSucceeded() {
  yield takeEvery(action.LOAD_USER_PROFILE,
    gCall(
      api.fetchUserInfo,
      action.userInfoFetchSucceeded,
      action.userInfoFetchFailed,
    ))
}

function* watchForLoginFailed() {
  yield takeEvery(action.USER_LOGIN_ERROR,
    redirectTo(route.user_not_found_path))
}

function* watchForRecoveryPassword() {
  yield takeEvery(action.RECOVERY_PASSWORD,
    gCall(api.recoveryPassword,
      action.userRecoveryPasswordSucceeded,
      action.userRecoveryPasswordFailed,
      route.campaigns_path,
    ))
}

function* watchForLogout() {
  yield takeEvery(action.LOGOUT,
    gCall(api.logoutUser,
      action.userLogout,
      null,
      route.login_path,
    ))
}

function* watchForUserNotFound() {
  yield takeEvery(action.USER_NOT_FOUND,
    gCall(api.userNotFound,
      action.emailUserNotFoundSucceeded,
      action.emailUserNotFoundFailed,
      route.campaigns_path,
    ))
}

function* watchForLogin() {
  yield takeEvery(action.LOGIN, function* _({ payload }) {
    let response = yield call(api.preLoginUser, payload)
    if (is_ok(response.data)) {
      response = yield call(api.loginUser, payload)
      if (is_ok(response.data)) {
        yield put(action.settings(response.data, payload))
        yield put(action.userFetchSucceeded(response.data, payload))
        yield put(push(route.campaigns_path(response.data, payload)))

        let badgeheroes_device_id = localStorage.getItem('badgeheroes_device_id')
        if (!badgeheroes_device_id) {
          const random = Math.floor(Math.random() * 1000000)
          const miliseconds = Date.now()
          badgeheroes_device_id = `${random}#${miliseconds}`
          localStorage.setItem('badgeheroes_device_id', badgeheroes_device_id)
        }
        yield call(api.updateDevice, {
          fcm_token: response.data.firebase_access_token,
          os: 'web',
          app_version: `webOs: ${webOs()}, userAgent: ${navigator.userAgent}`,
          device_id: badgeheroes_device_id,
        }, response.data.id)
      } else {
        alert('Contraseña incorrecta')
      }
    } else {
      yield put(action.userFetchFailed(payload))
    }
  })
}

function* watchForUpdateProfile() {
  yield takeEvery(action.USER_UPDATE_PROFILE,
    gCall(api.updateProfile,
      action.updateProfileSucceeded,
      action.updateProfileFailed,
    ))
}

function* watchForEditProfileInfo() {
  yield takeEvery(action.EDIT_PROFILE_INFO_FETCH,
    gCall(api.updateProfile,
      action.editProfileSucceeded,
      action.editProfileFailed,
    ))
}

function* watchForSelectMission() {
  yield takeEvery(action.SELECT_MISSION,
    gCall(api.missionInfo,
      action.selectMissionSucceeded,
      action.selectMissionFailed,
    ))
}

function* watchContact() {
  yield takeEvery(action.CONTACT,
    gCall(api.contact,
      action.contactSucceeded,
      action.contactFailed,
    ))
}

function* watchSettings() {
  yield takeEvery(action.SETTINGS,
    gCall(api.settings,
      action.settingsSucceeded,
      action.settingsFailed,
    ))
}

export default [watchForLogin, watchForLoginSucceeded, watchForUserNotFound,
  watchForLogout, watchForRecoveryPassword, watchForLoginFailed,
  watchForUpdateProfile, watchForEditProfileInfo, watchContact, watchSettings,
  watchForSelectMission, watchForUserInfoFetchSucceeded]



// WEBPACK FOOTER //
// ./src/sagas/user.jsx